// ** Third Party Components
import styled, { css } from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";
import { StyledCheckboxControl } from "./CheckboxControl.styled";
import { StyledHiddenCheckbox } from "./HiddenCheckbox.styled";

// #####################################################

export const StyledLabelBaseComponent = styled("label")`
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.element};

	${({ disabled }) =>
		disabled
			? css`
					cursor: no-drop;
					opacity: var(--dz-sys-button-disabled-opacity);
			  `
			: css`
					cursor: pointer;
			  `}

	svg {
		color: ${({ theme }) => theme.colors.whiteTrue};
	}

	${({ $registerInEmail }) =>
		$registerInEmail &&
		css`
			svg {
				color: var(--dz-ref-color-white);
			}
		`}

	${({ noPaddingX }) =>
		noPaddingX &&
		css`
			@media (max-width: ${breakpoints.phone - 1}px) {
				margin-left: -0.5rem;
			}
		`}

	${({ customPadding }) =>
		customPadding
			? css`
					@media (min-width: ${breakpoints.tablet}px) {
						padding: ${customPadding};
					}
			  `
			: css`
					padding: 0.25rem 0.5rem;
			  `}

	${({ $customPaddingAllDevices }) =>
		$customPaddingAllDevices &&
		css`
			padding: ${$customPaddingAllDevices};
		`}

	${({ hoverable }) =>
		hoverable &&
		css`
			&:hover {
				background-color: ${({ theme: { colors } }) => colors.itemsHover};

				${StyledHiddenCheckbox}:not(:checked) + ${StyledCheckboxControl} {
					background-color: ${({ theme: { colors } }) => colors.whiteTrue};

					&:hover {
						background-color: ${({ theme: { colors } }) => colors.itemsHover};
					}
				}


		`}}
`;

// #####################################################
